export default __webpack_public_path__ + "KaTeX_Size3-Regular.1ef7adae735724bab211320dddae3f21.woff2";